import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { UserFoldersEffects } from './user-folders.effects';
import { USER_FOLDERS_FEATURE_KEY, userFoldersReducer } from './user-folders.reducer';

@NgModule({
    imports: [StoreModule.forFeature(USER_FOLDERS_FEATURE_KEY, userFoldersReducer), EffectsModule.forFeature([UserFoldersEffects])]
})
export class UserFoldersStoreModule {}
